import './compatibility.js';

/* Vue :) */
import Vue from 'vue';

/* VueX store */
import store from '@/store/index.js';

/* Vue Router */
import VueRouter from 'vue-router';
Vue.use(VueRouter);

/* i18n plugin */
import i18n from '@/i18n/plugin.js';
Vue.use(i18n);

/* Store */
import './store/filters.js';
import './store/components.js';
import app from '@/store/app.js';

/* Add components */
import PhiPersonSet from '@/components/Phi/Person/Set.vue';
Vue.component('PhiPersonSet', PhiPersonSet);

import PhiPersonRelevancePicker from '@/components/Phi/Person/Relevance/Picker.vue';
Vue.component('PhiPersonRelevancePicker', PhiPersonRelevancePicker);

import PhiPostEditor from '@/components/Phi/Post/Editor.vue';
Vue.component('PhiPostEditor', PhiPostEditor);

import Flatpickr from '@/components/Flatpickr.vue';
Vue.component('Flatpickr', Flatpickr);

import PhiDestinationNotifications from '@/components/Phi/DestinationNotifications.vue';
Vue.component('PhiDestinationNotifications', PhiDestinationNotifications);

/* States */
import Highlights from '@/states/Highlights.vue';
import Inbox from '@/states/Inbox.vue';
import PostNotificationSettings from '@/states/Post/Notification/Settings.vue';
import PostTypes from '@/states/Post/Types.vue';
import PostTypesEdit from '@/states/Post/Types/Edit.vue';
import Settings from '@/states/Settings.vue';
import Thread from '@/states/Thread/Thread.vue';
import ThreadFeed from '@/states/Thread/Feed.vue';
import Classroom from '@/states/Classroom.vue';

/* Components */
const AbiturTable = () => import('@/modules/v3/components/AbiturTable/AbiturTable.vue');
const AcademicSchedule = () => import('@/modules/v3/components/Academic/Schedule/AcademicSchedule.vue');
const WorkloadDatePicker = () => import('@/modules/v3/components/V3WorkloadDatePicker/V3WorkloadDatePicker.vue');

const ChartJs = () => import('@/components/ChartJs.vue');
const CmsApiPage = () => import('@/modules/cms/components/Api/Page.vue');
const CmsApiPageEditor = () => import('@/modules/cms/components/Api/PageEditor.vue');
const CmsPage = () => import('@/modules/cms/components/Page/Page.vue');
const CmsPageEditor = () => import('@/modules/cms/components/Page/PageEditor.vue');
const HtmlEditor = () => import('@/modules/cms/components/Media/Html/HtmlEditor.vue');
const HtmlEditorToolbar = () => import('@/modules/cms/components/Media/Html/HtmlEditorToolbar.vue');
const CoreTypeManager = () => import('@/modules/core/components/Type/TypeManager.vue');
const DataCovidReport = () => import('@/modules/data/components/DataCovidReport/DataCovidReport.vue');
const DataDashboard = () => import('@/modules/data/components/Dashboard/Dashboard.vue');
const DataPersonDashboard = () => import('@/modules/data/components/Person/Dashboard.vue');
const DataPersonView = () => import('@/modules/data/components/Person/View.vue');
const DataViewEditor = () => import('@/modules/data/components/View/ViewEditor.vue');
const GeoTargetEditor = () => import('@/modules/geo/components/Api/Target/Editor.vue');
const LogReport = () => import('@/modules/v3/components/LogReport/LogReport.vue');
const NodePostEditor = () => import('@/modules/communication/components/Node/PostEditor.vue');
const PhiAttendanceAdmin = () => import('@/components/Phi/Attendance/Admin.vue');
const PhiAttendanceCheckpoint = () => import('@/components/Phi/Attendance/Checkpoint.vue');
const PhiCoreAvatarChange = () => import('@/modules/core-avatar/components/changeavatar/Changeavatar.vue');
const PhiGeoFeed = () => import('@/components/Phi/Geo/Feed.vue');
const PhiGeoTargetHistory = () => import('@/modules/geo/components/Api/Target/History.vue');
const PhiMercadopago = () => import('@/components/Phi/Mercadopago.vue');
const PhiPaymentRedsys = () => import('@/components/Phi/Payment/Redsys.vue');
const PhiPersonListItem = () => import('@/components/Phi/Person/ListItem.vue');
const PhiPostListItem = () => import('@/components/Phi/Post/ListItem.vue');
const PhiProtecData = () => import('@/modules/v3/components/Protecdata/components/Protecdata.vue');
const PhiProtecDataTable = () => import('@/modules/v3/components/Protecdata/components/ProtecDataTable.vue');
const PhiStoreHeader = () => import('@/components/Phi/Store/Header.vue');
const PhiStoreRecharge = () => import('@/components/Phi/Store/Recharge.vue');
const PhiStoreTransaction = () => import('@/components/Phi/Store/Transaction.vue');
const PhiThreadFeed = () => import('@/components/Phi/Thread/Feed.vue');
const PhiThreadFilters = () => import('@/components/Phi/Thread/Filters.vue');
const PhiTucompra = () => import('@/components/Phi/Tucompra.vue');
const PhiV3AcademicExtracurricularForm = () => import('@/components/Phi/V3/Academic/Extracurricular/Form.vue');
const PhiV3AcademicExtracurricularFormBuilder = () => import('@/components/Phi/V3/Academic/Extracurricular/FormBuilder.vue');
const PhiV3AcademicExtracurricularSummary = () => import('@/components/Phi/V3/Academic/Extracurricular/Summary.vue');
const PhiV3AcademicExtracurricularSummaryBuilder = () => import('@/components/Phi/V3/Academic/Extracurricular/SummaryBuilder.vue');
const PhiV3AcademicPeriodPicker = () => import('@/modules/v3/components/V3AcademicPeriodPicker/V3AcademicPeriodPicker.vue');
const PhiV3BillingPeriodPicker = () => import('@/components/Phi/V3/Billing/Period/Picker.vue');
const PhiV3BillingEntityPicker = () => import('@/components/Phi/V3/Billing/Entity/Picker.vue');

const PhiV3DebitPlanPicker = () => import('@/components/Phi/V3/Debit/Plan/PlanPicker.vue');

const PhiV3PersonStudentPrecedents = () => import('@/modules/v3/components/V3PersonStudentPrecedents/V3PersonStudentPrecedents.vue');
const PostList = () => import('@/modules/communication/components/Post/PostList.vue');
const StoreHeader = () => import('@/modules/store/components/Header.vue');
const StoreHistory = () => import('@/modules/store/components/History.vue');
const ThreadChat = () => import('@/modules/communication/components/Thread/Chat.vue');
const UiCard = () => import('@/modules/ui/components/UiCard/UiCard.vue');
const UiCardEditor = () => import('@/modules/ui/components/UiCard/UiCardEditor.vue');
const UiDialog = () => import('@/modules/ui/components/UiDialog/UiDialog.vue');
const UiDrawer = () => import('@/modules/ui/components/UiDrawer/UiDrawer.vue');
const UiIcon = () => import('@/modules/ui/components/UiIcon/UiIcon.vue');
const UiInput = () => import('@/modules/ui/components/UiInput/UiInput.vue');
const UiItem = () => import('@/modules/ui/components/UiItem/UiItem.vue');
const UiTab = () => import('@/modules/ui/components/UiTabs/UiTab.vue');
const UiTabs = () => import('@/modules/ui/components/UiTabs/UiTabs.vue');
const UiSelect = () => import('@/modules/ui/components/UiSelect/UiSelect.vue');
const UiUploadImage = () => import("@/modules/ui/components/UiUploadImage/UiUploadImage.vue");
const UiAccordion = () => import("@/modules/ui/components/_Accordion/Accordion.vue");
const UiFullScreenPicture = () => import("@/modules/ui/components/UiFullScreenPicture/UiFullScreenPicture.vue");
const UiPickerLocation = () => import("@/modules/ui/components/UiPickerLocation/UiPickerLocation.vue");

const V3AcademicCourseDataEditor = () => import('@/modules/v3/components/V3AcademicCourseDataEditor/V3AcademicCourseDataEditor.vue');
const V3AcademicPersonGroups = () => import('@/modules/v3/components/V3AcademicPersonGroups/V3AcademicPersonGroups.vue');
const V3AttendanceConsolidate = () => import('@/modules/v3/components/V3AttendanceConsolidate/V3AttendanceConsolidate.vue');
const V3ExtracurricularInscriptionManager = () => import('@/modules/v3/components/V3ExtracurricularInscriptionManager/V3ExtracurricularInscriptionManager.vue');
const V3ExtracurricularSlotManager = () => import('@/modules/v3/components/V3ExtracurricularSlotManager/V3ExtracurricularSlotManager.vue');
const V3GeoTargetHistory = () => import('@/modules/v3/components/V3TransportTargetHistory/V3TransportTargetHistory.vue');
const V3DianLog = () => import('@/modules/v3/components/V3DianLog/V3DianLog.vue');

const V3ProcessNotifyReport = () => import('@/modules/v3/components/V3ProcessNotifyReport/V3ProcessNotifyReport.vue');

const PlaneacionDominioManager = () => import('@/modules/v3/planeacion/components/PlaneacionDominioManager/PlaneacionDominioManager.vue');
const PlaneacionProductoManager = () => import('@/modules/v3/planeacion/components/PlaneacionProductoManager/PlaneacionProductoManager.vue');
const PlaneacionUnidadManager = () => import('@/modules/v3/planeacion/components/PlaneacionUnidadManager/PlaneacionUnidadManager.vue');
const PlaneacionUnidadDesglose = () => import('@/modules/v3/planeacion/components/PlaneacionUnidadDesglose/PlaneacionUnidadDesglose.vue');
const PlaneacionControl = () => import('@/modules/v3/planeacion/components/PlaneacionControl/PlaneacionControl.vue');
const PlaneacionUnidadGrading = () => import('@/modules/v3/planeacion/components/PlaneacionUnidadGrading/PlaneacionUnidadGrading.vue');
const UnidadProductoGrading = () => import('@/modules/v3/planeacion/components/UnidadProductoGrading/UnidadProductoGrading.vue');
const UnidadProductoResults = () => import('@/modules/v3/planeacion/components/UnidadProductoResults/UnidadProductoResults.vue');
const PlaneacionUnidadConsulta = () => import('@/modules/v3/planeacion/components/PlaneacionUnidadConsulta/PlaneacionUnidadConsulta.vue');
const PlaneacionProductoPicker = () => import('@/modules/v3/planeacion/components/PlaneacionProductoPicker/PlaneacionProductoPicker.vue');
const PlaneacionProductoEditor = () => import('@/modules/v3/planeacion/components/PlaneacionProductoEditor/PlaneacionProductoEditor.vue');

const AcademicCourseLinks = () => import('@/modules/v3/planeacion/components/AcademicCourseLinks/AcademicCourseLinks.vue');

const EsignConsent = () => import('@/modules/esign/components/EsignConsent/EsignConsent.vue');

const EcTransaction = () => import('@/modules/ecommerce/components/Transaction/Transaction.vue');
const MercadoPagoReport = () => import('@/modules/ecommerce/components/Mercadopago/Report.vue');
const EcommerceChargeBuilder = () => import('@/modules/ecommerce/components/ChargeBuilder/ChargeBuilder.vue');
const EcommercePaymentButton = () => import('@/modules/ecommerce/components/PaymentButton/PaymentButton.vue');
const EcommerceGatewayManager = () => import('@/modules/ecommerce/components/GatewayManager/GatewayManager.vue');

const V3QuieromifacturaLog = () => import('@/modules/v3/components/V3QuieromifacturaLog/V3QuieromifacturaLog.vue');

const PhiPrivacy = () => import('@/components/Phi/Privacy.vue');
const PhiSignioDataTable = () => import('@/modules/v3/components/Signio/components/SignioDataTable.vue');

//Componente popUp pasarelas con mensaje de seguridad
const EcommercePopUp = () => import('@/modules/v3/components/V3EcommercePayments/v3EcommercePayments.vue');

const TinyMce2 = () => import('@/components/TinyMce2.vue');

const PhiSignio = () => import('@/modules/v3/components/Signio/components/Signio.vue');

// import terms
// import '../public/tinymce/langs'

// Mixins
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import useApi from '@/modules/api/mixins/useApi.js';
import apiAcademicGroup from '@/modules/v3/api/academic/group.js';

export default {
    Vue: class {
        constructor(vueOptions) {
            vueOptions.store = store;

            vueOptions.provide = function () {
                return {
                    $ioToken: store.state.token
                };
            };

            return new Vue(vueOptions);
        }
    },

    VueRouter,
    app,
    store,

    mixins: {
        useApi,
        useI18n
    },

    api: {
        apiAcademicGroup
    },

    states: {
        Highlights,
        Inbox,
        PostNotificationSettings,
        PostTypes,
        PostTypesEdit,
        Settings,
        Thread,
        ThreadFeed,
        Classroom,
    },
    components: {
        PlaneacionDominioManager,
        PlaneacionProductoManager,
        PlaneacionUnidadManager,
        PlaneacionUnidadDesglose,
        PlaneacionControl,
        PlaneacionUnidadGrading,
        UnidadProductoGrading,
        UnidadProductoResults,
        PlaneacionUnidadConsulta,
        PlaneacionProductoPicker,
        PlaneacionProductoEditor,
        ReevaluacionGrading: () => import('@/modules/v3/planeacion/reevaluacion/components/Reevaluacion/ReevaluacionGrading.vue'),
        AreaControl: () => import('@/modules/v3/planeacion/control/components/AreaControl/AreaControl.vue'),

        AcademicCourseLinks,

        AcademicClassbook: () => import('@/modules/v3/classbook/components/AcademicClassbook/AcademicClassbook.vue'),
        AcademicClassbookSection: () => import('@/modules/v3/classbook/components/AcademicClassbook/AcademicClassbookSection.vue'),
        AcademicClassbookTeacher: () => import('@/modules/v3/classbook/components/AcademicClassbook/AcademicClassbookTeacher.vue'),

        AcademicReportStudent: () => import('@/modules/v3/planeacion/components/AcademicReportStudent/AcademicReportStudent.vue'),

        EcTransaction,
        AbiturTable,
        AcademicSchedule,
        WorkloadDatePicker,
        ChartJs,
        CmsApiPage,
        CmsApiPageEditor,
        CmsPage,
        CmsPageEditor,
        HtmlEditor,
        HtmlEditorToolbar,
        CoreTypeManager,
        DataCovidReport,
        DataDashboard,
        DataPersonDashboard,
        DataPersonView,
        DataViewEditor,
        GeoTargetEditor,
        LogReport,
        MercadoPagoReport,
        NodePostEditor,
        PhiAttendanceAdmin,
        PhiAttendanceCheckpoint,
        PhiCoreAvatarChange,
        PhiGeoFeed,
        PhiGeoTargetHistory,
        PhiMercadopago,
        PhiPaymentRedsys,
        PhiPersonListItem,
        PhiPostListItem,
        PhiProtecData,
        PhiStoreHeader,
        PhiStoreRecharge,
        PhiStoreTransaction,
        PhiThreadFeed,
        PhiThreadFilters,
        PhiTucompra,
        PhiV3AcademicExtracurricularForm,
        PhiV3AcademicExtracurricularFormBuilder,
        PhiV3AcademicExtracurricularSummary,
        PhiV3AcademicExtracurricularSummaryBuilder,
        PhiV3AcademicPeriodPicker,
        PhiV3BillingPeriodPicker,
        PhiV3PersonStudentPrecedents,
        PostList,
        StoreHeader,
        StoreHistory,
        ThreadChat,
        UiCard,
        UiCardEditor,
        UiDialog,
        UiDrawer,
        UiIcon,
        UiInput,
        UiItem,
        UiTab,
        UiTabs,
        UiSelect,
        UiUploadImage,
        UiAccordion,
        UiFullScreenPicture,
        UiPickerLocation,
        V3AcademicCourseDataEditor,
        V3AcademicPersonGroups,
        V3AttendanceConsolidate,
        V3ExtracurricularInscriptionManager,
        V3ExtracurricularSlotManager,
        V3GeoTargetHistory,
        V3DianLog,
        V3ProcessNotifyReport,
        PhiProtecDataTable,
        EsignConsent,
        EcommerceChargeBuilder,
        EcommercePaymentButton,
        EcommerceGatewayManager,
        V3QuieromifacturaLog,
        PhiPrivacy,
        PhiSignioDataTable,
        PhiV3BillingEntityPicker,
        EcommercePopUp,
        TinyMce2,
        PhiV3DebitPlanPicker,
        PhiSignio,
    }
};
